import { type FC, type PropsWithChildren } from 'react'
import { cn } from '@playbooks/ui/lib/utils'

import { useTranslation } from '../../../contexts/localization/Localization'
import { useAppContext } from '../../../contexts/AppContext'
import useScrollHighlightedIntoView from '../../../hooks/useScrollHighlightedIntoView'

const Highlighter: FC<PropsWithChildren<{ id: number; showFrame?: boolean }>> = ({
  id,
  children,
  showFrame = true,
}) => {
  const { highlightedIds } = useAppContext()
  const isHighlighted = highlightedIds.some(value => value === id)

  return (
    <div className={`relative flex`}>
      {children}
      {isHighlighted && <Frame id={id} showFrame={showFrame} />}
    </div>
  )
}

const Frame: FC<{
  id: number
  showFrame?: boolean
}> = ({ id, showFrame = true }) => {
  const { text } = useTranslation()
  const ref = useScrollHighlightedIntoView()

  return (
    <div
      aria-hidden={!showFrame}
      ref={ref}
      data-highlighter-container
      data-testid={`highlighter_${id}`}
      className={cn(
        `
            absolute h-full w-full border-solid z-1
            border-red-500 dark:border-red-900 border border-b-4 rounded-md top-0
            text-red-500 dark:text-red-900 pointer-events-none
          `,
        !showFrame && 'opacity-0',
      )}
    >
      <span data-testid="highlighter_label" className={`absolute text-[12px] right-2 bottom-0 `}>
        {text('questionRequiredLabel')}
      </span>
    </div>
  )
}
export default Highlighter
